<template>


  <section
                class=" d-none elementor-section elementor-top-section elementor-element elementor-element-8fcc0cc elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default default"
                data-id="8fcc0cc" data-element_type="section">
                <div class="elementor-container elementor-column-gap-default">
                  <div
                    class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6123c63"
                    data-id="6123c63" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-14fef9c elementor-widget elementor-widget-image"
                        data-id="14fef9c" data-element_type="widget" data-widget_type="image.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-widget-container"> <img loading="lazy" decoding="async" width="600"
                              height="600" src="https://moverz.themeht.com/wp-content/uploads/2024/10/41-800x800.jpg"
                              class="attachment-moverz-700x700 size-moverz-700x700 wp-image-1163" alt=""
                              sizes="(max-width: 700px) 100vw, 700px" /> </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-406a351"
                    data-id="406a351" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-81e980d elementor-widget elementor-widget-title"
                        data-id="81e980d" data-element_type="widget" data-widget_type="title.default">
                        <div class="elementor-widget-container">

                          <div class="theme-title  ">
                            <h6>About Us</h6>

                            <h2 class="text-anime-style"> We are the best moving company in the world.</h2>
                            <div class="title-divider "><span class="title-divider-separator"></span></div>
                            <p>We endeavor to comprehend what they’re going through, what they need what their price
                              tags are, and what means quite a bit to them and their clients.</p>
                          </div>



                        </div>
                      </div>
                      <section
                        class="elementor-section elementor-inner-section elementor-element elementor-element-62df3b4 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default default"
                        data-id="62df3b4" data-element_type="section">
                        <div class="elementor-container elementor-column-gap-default">
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-161e5be"
                            data-id="161e5be" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-f0b9091 elementor-widget elementor-widget-progress"
                                data-id="f0b9091" data-element_type="widget" data-widget_type="progress.default">
                                <div class="elementor-widget-container">
                                  <span class="elementor-title" id="elementor-progress-bar-f0b9091">
                                    Road Freight </span>

                                  <div aria-labelledby="elementor-progress-bar-f0b9091"
                                    class="elementor-progress-wrapper" role="progressbar" aria-valuemin="0"
                                    aria-valuemax="100" aria-valuenow="85">
                                    <div class="elementor-progress-bar" data-max="85">
                                      <span class="elementor-progress-text"></span>
                                      <span class="elementor-progress-percentage">85%</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="elementor-element elementor-element-5761b13 elementor-widget elementor-widget-progress"
                                data-id="5761b13" data-element_type="widget" data-widget_type="progress.default">
                                <div class="elementor-widget-container">
                                  <span class="elementor-title" id="elementor-progress-bar-5761b13">
                                    Train Freight </span>

                                  <div aria-labelledby="elementor-progress-bar-5761b13"
                                    class="elementor-progress-wrapper" role="progressbar" aria-valuemin="0"
                                    aria-valuemax="100" aria-valuenow="90">
                                    <div class="elementor-progress-bar" data-max="90">
                                      <span class="elementor-progress-text"></span>
                                      <span class="elementor-progress-percentage">90%</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="elementor-element elementor-element-0de5a43 elementor-widget elementor-widget-progress"
                                data-id="0de5a43" data-element_type="widget" data-widget_type="progress.default">
                                <div class="elementor-widget-container">
                                  <span class="elementor-title" id="elementor-progress-bar-0de5a43">
                                    Ocean Freight </span>

                                  <div aria-labelledby="elementor-progress-bar-0de5a43"
                                    class="elementor-progress-wrapper" role="progressbar" aria-valuemin="0"
                                    aria-valuemax="100" aria-valuenow="70">
                                    <div class="elementor-progress-bar" data-max="70">
                                      <span class="elementor-progress-text"></span>
                                      <span class="elementor-progress-percentage">70%</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c8dbb90"
                            data-id="c8dbb90" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-c9b7823 elementor-widget elementor-widget-list_style"
                                data-id="c9b7823" data-element_type="widget" data-widget_type="list_style.default">
                                <div class="elementor-widget-container">

                                  <!-- Start rendering the output -->

                                  <ul class="list-unstyled list-icon style-1">
                                    <li><i class="flaticon flaticon-check-mark-1"></i> Expertise and Experience</li>
                                    <li><i class="flaticon flaticon-check-mark-1"></i> Customer-Centic Approach</li>
                                    <li><i class="flaticon flaticon-check-mark-1"></i> Always Work With Energetic Team
                                    </li>
                                    <li><i class="flaticon flaticon-check-mark-1"></i> We are Award Winning Company</li>
                                  </ul>

                                  <!-- End rendering the output -->



                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>

  <section style="background-color: #e11c09 !important"
                class="elementor-section elementor-top-section elementor-element elementor-element-e7c82ca elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default default"
                data-id="e7c82ca" data-element_type="section"
                data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
                <div class="elementor-container elementor-column-gap-default">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-da9150c"
                    data-id="da9150c" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-e2d9b1b elementor-widget elementor-widget-marquee-animation"
                        data-id="e2d9b1b" data-element_type="widget" data-widget_type="marquee-animation.default">
                        <div class="elementor-widget-container">

                          <div class="marquee-wrap marquee_mode">
                            <div class="marquee-inner">
                              <div class="marquee-text ">
                                <span>Delivery Service</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                              <div class="marquee-text ">
                                <span>Movers</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                              <div class="marquee-text ">
                                <span>Warehousing</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                              <div class="marquee-text ">
                                <span>Logistic</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                              <div class="marquee-text ">
                                <span>Transportation</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                              <div class="marquee-text ">
                                <span>Packers</span>
                                <i class="flaticon flaticon-truck-4"></i>
                              </div>
                            </div>
                          </div>




                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
</template>

<script>
export default {
 
  data() {
    return {
      
    };
  },
  
};
</script>

<style scoped>

@import "@/assets/theme-style6c2d.css";



</style>
